export default __webpack_public_path__ + "static/media/cm_1.fa80d6be.png";